import React, { useState, useEffect, memo } from "react";
import Chart from "react-apexcharts";
import Button from "@atlaskit/button";
import Spinner from "@atlaskit/spinner";
import useFetch from "../../../../hooks/use-fetch";
import styles from "./JobOverview.module.css";

const JobOverview = ({ appType }) => {
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [timeline, setTimeline] = useState(0);
  const url = `api/dashboard/widget/jobs/history-stats?jobType=${appType}&timeline=${timeline}`;
  const { data, isLoading: apiLoading, error: errorMessage } = useFetch(url);
  const { dataLog: jobOverview, totalCount } = { ...data };

  useEffect(() => {
    if (jobOverview) {
      const success = jobOverview.map((ele) => {
        return Object.values(ele)[0];
      });
      const partialSuccess = jobOverview.map((ele) => {
        return Object.values(ele)[2];
      });
      const failure = jobOverview.map((ele) => {
        return Object.values(ele)[1];
      });
      const dates = jobOverview.map((ele) => {
        return Object.values(ele)[3];
      });

      const jobSeries = [
        {
          name: "Successful",
          data: [...success],
        },
        {
          name: "Partially successful",
          data: [...partialSuccess],
        },
        {
          name: "Failed",
          data: [...failure],
        },
      ];
      setSeries(jobSeries);

      setOptions({
        chart: {
          height: 350,
          type: "bar",
          stacked: true,
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
          toolbar: {
            show: false,
            autoSelected: "zoom",
          },
        },
        colors: ["#36B37E", "#FFAB00", "#FF5630"],
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          categories: [...dates],
          title: {
            text: "Date",
            offsetY: 5,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 5,
          },
        },
        yaxis: {
          title: {
            text: "No. of Jobs",
          },
          labels: {
            formatter: function (val) {
              return val.toFixed(0);
            },
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: 0,
          offsetX: -45,
        },
      });
    }
    setLoading(false);
  }, [jobOverview]);

  return (
    <div className={styles.container}>
      <div className={styles.buttonContainer}>
        <div className={styles.title}>Jobs history</div>
        <div>
          <Button
            appearance={timeline === 0 ? "primary" : "default"}
            onClick={() => {
              setLoading(true);
              setTimeline(0);
            }}
          >
            14 Days
          </Button>
          <Button
            appearance={timeline === 1 ? "primary" : "default"}
            onClick={() => {
              setLoading(true);
              setTimeline(1);
            }}
          >
            1 Month
          </Button>
          <Button
            appearance={timeline === 2 ? "primary" : "default"}
            onClick={() => {
              setLoading(true);
              setTimeline(2);
            }}
          >
            3 Month
          </Button>
        </div>
      </div>
      {isLoading || apiLoading || !jobOverview ? (
        <div className={styles.spinner}>
          <Spinner size="large" />
        </div>
      ) : totalCount === 0 ? (
        <div className={styles.noData}>
          {appType === "Backup" ? (
            <div className={styles.item}>
              <strong>No Backups Found</strong>
            </div>
          ) : (
            <div className={styles.item}>
              <strong>No Restores Found</strong>
            </div>
          )}
        </div>
      ) : (
        <Chart options={options} series={series} type="bar" height={350} />
      )}
    </div>
  );
};
export default memo(JobOverview);
